import { useQuery } from "@tanstack/react-query";
import {
  fetchUsersByRole,
  type BouncerRoleName,
} from "../../../services/bouncerUsers";

export function useUsersByRole(
  role: BouncerRoleName,
  options: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: ["bouncer-users-by-role", role],
    queryFn: () => fetchUsersByRole(role),
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
    enabled: options.enabled ?? true,
  });
}
